export type FindingReview = {
  title: string
  what: string
  why: string
  where: string
  snippet: string
  fix: string
}

type FindingLike = {
  title?: string | null
  description?: string | null
  impact?: string | null
  primary_location?: string | null
  line_number?: number | null
  remediation_guidance?: string | null
  extra_metadata?: Record<string, unknown> | null
  metadata?: Record<string, unknown> | null
}

function asText(value: unknown): string {
  return typeof value === 'string' ? value.trim() : ''
}

function stripMashed(raw: string): { what: string; why: string; where: string; snippet: string } {
  let rest = (raw || '').replace(/\r\n/g, '\n').trim()
  if (!rest) return { what: '', why: '', where: '', snippet: '' }

  let snippet = ''
  let where = ''
  let why = ''

  const snippetParts = rest.split(/\n+\s*Snippet:\s*/i)
  if (snippetParts.length > 1) {
    snippet = snippetParts.slice(1).join('\n').trim()
    rest = snippetParts[0]
  }

  const evidenceParts = rest.split(/\n+\s*Evidence:\s*/i)
  if (evidenceParts.length > 1) {
    where = evidenceParts.slice(1).join('\n').trim()
    rest = evidenceParts[0]
  }

  const whyParts = rest.split(/\n+\s*Why it matters:\s*/i)
  if (whyParts.length > 1) {
    why = whyParts.slice(1).join('\n').trim()
    rest = whyParts[0]
  }

  return {
    what: rest.replace(/\n{3,}/g, '\n\n').trim(),
    why,
    where,
    snippet,
  }
}

export function buildFindingReview(finding: FindingLike): FindingReview {
  const extra = finding.extra_metadata || finding.metadata || {}
  const mashed = stripMashed(finding.description || '')
  const whereFromFields = [finding.primary_location, finding.line_number]
    .filter((part) => part !== null && part !== undefined && part !== '')
    .join(':')

  const what = mashed.what || asText(extra.message) || (finding.description || '').trim()
  const why = mashed.why || (finding.impact || '').trim() || asText(extra.why_it_matters)
  const where = mashed.where || whereFromFields || asText(extra.file_path)
  const snippet = mashed.snippet || asText(extra.snippet)
  const fix = (finding.remediation_guidance || '').trim() || asText(extra.remediation)

  return {
    title: (finding.title || '').trim(),
    what,
    why,
    where,
    snippet,
    fix,
  }
}

export function paragraphize(text: string): string[] {
  return (text || '')
    .split(/\n{2,}/)
    .map((part) => part.replace(/\s+/g, ' ').trim())
    .filter(Boolean)
}
